import React from "react";
import ModalDelete from "./ModalDelete";

const DataCardUser = ({ data }) => {
  return (
    <div className="grid md:grid-cols-4 grid-cols-2 gap-4 mt-5">
      {Array.isArray(data) &&
        data.map((item) => (
          <div
            className="card bg-white card-compact border h-34 md:h-36 w-full shadow-sm flex gap-4 flex-row "
            key={item.id}
          >
            <div className="p-5 w-full">
              <div className="flex justify-between">
                <p className="card-title text-gray-400 text-[12px] md:text-[14px] ">
                  {item.name}
                </p>
                <div className="card-actions">
                  <ModalDelete item={item} />
                </div>
              </div>
              <p className="text-black font-[500] grow-0 pb-2 text-[12px] md:text-[14px] ">
                {item.nip}
              </p>
              <div className="flex justify-between text-[12px] md:text-[14px] ">
                <p
                  className="grow-0 "
                  style={{
                    color: "#0C2240",
                  }}
                >
                  {item.division}
                </p>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default DataCardUser;
